module.exports = __webpack_public_path__ + "static/media/image_.2fbdf4ef.svg";